import { createRangeTagManager } from '../../utils/createRangeTagManager';

export const totalFloorsTagManager = createRangeTagManager({
  jsonQueryKey: 'floorn',
  template: 'Этажей в доме %s',
  id: 'totalFloors',
});
